import { ParentProfile } from "./ParentProfile";
import { useLearnerContext } from "../../contexts/LearnerContext";
import { ProfilePage } from "./ProfilePage";
import { Skeleton } from "../Skeleton";

export const ParentProfileSwitcher: React.FC = () => {
  const { learner } = useLearnerContext();
  if (!learner) {
    return (
      <ProfilePage>
        <div className="flex h-[528px] w-[1288px] max-w-full flex-col gap-8 rounded-2xl border border-dm-charcoal-100 bg-white p-6">
          <Skeleton />
        </div>
      </ProfilePage>
    );
  }
  return <ParentProfile />;
};
